import { render, staticRenderFns } from "./DeptNameTag.vue?vue&type=template&id=5e30178d&scoped=true"
import script from "./DeptNameTag.vue?vue&type=script&lang=js"
export * from "./DeptNameTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30178d",
  null
  
)

export default component.exports